'use strict';

import cookie from 'cookie-monster';
import store from 'store';

import { getConfig } from '@utils/Env';

const COOKIE_NAME = 'm_var';

function getCookieEntry() {
    return document.cookie.split(/;\s*/).find((part) => part.startsWith(`${COOKIE_NAME}=`));
}

function getCookieQuery(entry) {
    if (!entry) {
        return {};
    }

    return Object.fromEntries(new URLSearchParams(entry.slice(COOKIE_NAME.length + 1)));
}

// The marketing site writes the cookie on the parent domain, so we must expire it on the same domain.
function clearCookie() {
    cookie.setItem(COOKIE_NAME, '', {
        expires: new Date(0).toUTCString(),
        domain: getConfig('www_host').replace('www.', '.'),
        path: '/',
        secure: true,
    });
}

export function recordMarketingVariables(query = {}) {
    const mvars = store.get('m_var') || {};
    const cookieEntry = getCookieEntry();
    const tags = query.utm_campaign ? query : getCookieQuery(cookieEntry);

    // Read the cookie only once. It lives for 30 days, so if we keep it, an old campaign
    // replaces a newer one from an app address on the next visit.
    if (cookieEntry) {
        clearCookie();
    }

    if (!tags.utm_campaign || tags.utm_campaign === mvars.campaign) {
        return false;
    }

    store.set('m_var', {
        source: tags.utm_source,
        campaign: tags.utm_campaign,
        medium: tags.utm_medium || null,
        content: tags.utm_content || null,
        sref: query.sref || null,
    });

    return true;
}
